import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="element"
export default class extends Controller {
	hide() {
		this.element.hidden = true
	}
}
